// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyArykPF5dYOpwD42EdvCjBXs2ZFQuScG2g",
  authDomain: "grcord-90a6f.firebaseapp.com",
  databaseURL:
    "https://grcord-90a6f-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "grcord-90a6f",
  storageBucket: "grcord-90a6f.appspot.com",
  messagingSenderId: "279248063259",
  appId: "1:279248063259:web:76d874a45df464de56e1be",
};

// Initialize Firebase
initializeApp(firebaseConfig);
